import { css } from '@emotion/react';

export const dashboardHeaderContainer = css`
  padding-bottom: var(--fabric-space-gap-md);
`;

export const dashboardHeader = css`
  display: grid;
  grid-template-columns: max-content max-content minmax(0, 1fr) max-content max-content;
  align-items: center;

  // This renders the label and icon from the header a single line aligned with the info icon
  > h3:first-of-type {
    grid-column: 1 / 2;
    white-space: nowrap;
  }
`;

export const infoIconContainer = css`
  grid-column: 2 / 3;
  width: fit-content;
  margin-left: var(--fabric-geometry-standard-space-padding-xxs);
`;

export const progressSwitcherWrapper = (isWidthSmall?: boolean) => css`
  grid-column: 4 / 5;
  white-space: nowrap;

  ${isWidthSmall &&
  css`
    grid-row: 2;
    grid-column: 1 / -1;
    margin-top: var(--fabric-geometry-standard-space-padding-xs);
  `}
`;

export const timeRangeSelectorButton = (isWidthSmall?: boolean) => css`
  grid-column: 5 / 6;
  white-space: nowrap;
  margin-left: ${isWidthSmall ? '0' : 'var(--fabric-geometry-standard-space-padding-xs)'};
`;
